<button
	class="cancel-button"
	data-quat="action_cancelButton"
>Cancel</button>
